// extracted by mini-css-extract-plugin
export var chip = "_61-0";
export var filterDropdown = "_61-5";
export var filterItem = "_61-6";
export var icon = "_61-1";
export var removeButton = "_61-3";
export var removeIcon = "_61-4";
export var separator = "_61-2";